export default __webpack_public_path__ + "static/media/senior-sample7.dea342a8.png";